import { useEffect, useState } from 'react'
import ProblemReporter from '../ProblemReporter'
import AdminReports from './AdminReports'
import { createAdminCommands } from './commands'
/** Command ownership survives modal close/reopen; verified identity changes reset it. */
export default function AdminProblemReporter({
  routeId,
  showLauncher,
}: {
  routeId: string
  showLauncher?: boolean
}) {
  const [commands, setCommands] = useState<ReturnType<
    typeof createAdminCommands
  > | null>(null)
  useEffect(() => {
    let cancelled = false,
      owned: ReturnType<typeof createAdminCommands> | null = null
    void Promise.resolve().then(() => {
      if (!cancelled) {
        owned = createAdminCommands()
        setCommands(owned)
      }
    })
    return () => {
      cancelled = true
      owned?.dispose()
    }
  }, [])
  if (!commands) return null
  return (
    <ProblemReporter
      routeId={routeId}
      showLauncher={showLauncher}
      renderAdmin={(surface) => (
        <AdminReports {...surface} commands={commands} />
      )}
    />
  )
}
